enum Daytime {
	MORNING = 4,
	NOON = 12,
	EVENING = 17,
}

export const getGreetingData = (date = new Date()) => {
	const hour = date.getHours();

	const greeting =
		hour >= Daytime.MORNING && hour < Daytime.NOON
			? 'morning'
			: hour >= Daytime.NOON && hour < Daytime.EVENING
				? 'afternoon'
				: 'evening';

	return {
		greeting,
		weekday: date.toLocaleString('en-US', { weekday: 'long' }).toLocaleLowerCase(),
		month: date.toLocaleString('en-US', { month: 'long' }).toLocaleLowerCase(),
		day: date.getDate(),
		year: date.getFullYear(),
	};
};
